import api from 'shared/api'

const FETCH_REQUEST = 'minorGovernments/FETCH_REQUEST'
const FETCH_SUCCESS = 'minorGovernments/FETCH_SUCCESS'
const FETCH_MINOR_GOVERNMENT_SUCCESS = 'minorGovernments/FETCH_MINOR_GOVERNMENT_SUCCESS'
const FETCH_FAILURE = 'minorGovernments/FETCH_FAILURE'

const FETCH_REPORT_REQUEST = 'minorGovernments/FETCH_REPORT_REQUEST'
const FETCH_COMPANY_REPORT_SUCCESS = 'minorGovernments/FETCH_COMPANY_REPORT_SUCCESS'
const FETCH_REPORT_FAILURE = 'minorGovernments/FETCH_REPORT_FAILURE'

const initialState = {
  minorGovernments: [],
  loadedMinorGovernments: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  errors: [],
  reportData: {},
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchMinorGovernmentSuccess(payload) {
  return {
    type: FETCH_MINOR_GOVERNMENT_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchReportRequest(payload = {}) {
  return {
    type: FETCH_REPORT_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchReportSuccess(payload) {
  return {
    type: FETCH_COMPANY_REPORT_SUCCESS,
    payload,
  }
}

export function fetchReportFailure(errors = []) {
  return {
    type: FETCH_REPORT_FAILURE,
    errors,
  }
}

export function loadMinorGovernment(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.minorGovernments.loadedIds ? state.minorGovernments.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    return api(`api/v1/other_governments/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchMinorGovernmentSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

export function loadGovernmentReport(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.minorGovernments.loadedIds ? state.minorGovernments.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchReportRequest({ loadedIds }))

    return api(`api/v1/other_governments/${id}/report`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchReportSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchReportFailure(json.errors))
      })
  }
}

export function loadMinorGovernments(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api('api/v1/other_governments', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        minorGovernments: [...payload]
      })
    case FETCH_MINOR_GOVERNMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedMinorGovernments: [
          ...state.loadedMinorGovernments,
          payload
        ]
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    case FETCH_REPORT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_COMPANY_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        reportData: {
          ...payload
        },
      })
    case FETCH_REPORT_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    default:
      return state
  }
}

